module.exports = __webpack_public_path__ + "public/images/Outschool_SocialIcon.46f320d579385d19fe12ffbf0e956ba8.png";